import { getShallowRgObj } from "./index235.js";
import { dequal } from "dequal";
function areRgObjectsEqual(a, b) {
	return dequal(getShallowRgObj(a), getShallowRgObj(b));
}
export { areRgObjectsEqual };

//# sourceMappingURL=index236.js.map